export default __webpack_public_path__ + "static/media/revolver.871fa3c7.svg";